module.exports = __webpack_public_path__ + "static/img/h3.178292b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h3.jpg
// module id = nMUh
// module chunks = 0